import Repository from './Repository'

export const getHeaders = (access_token?: string, formDataContent = false) => {
  return {
    Authorization: access_token ? access_token : null,
    'Content-Type': formDataContent ? 'multipart/form-data' : 'application/json',
  }
}

export default {
  getStore(access_token: string, id: string) {
    return Repository(getHeaders(access_token)).get(`/advertiser/stores/${id}`)
  },
  updateStore(access_token: string, id: string, data) {
    return Repository(getHeaders(access_token)).patch(`/advertiser/stores/${id}`, data)
  },
  updateStoreLogo(access_token: string, id: string, data) {
    if (data) {
      return Repository(getHeaders(access_token, true)).post(
        `/advertiser/stores/${id}/upload-logo`,
        data,
      )
    }
  },
  getStripeCustomerSession(access_token, storeId) {
    return Repository(getHeaders(access_token, true)).get(`/advertiser/${storeId}/stripe/session`)
  },
  getInfluencer(access_token, store, userId) {
    return Repository(getHeaders(access_token)).get(
      `/advertiser/stores/${store}/users/${userId}/dashboard`,
    )
  },
  updateCampaignLogo(access_token, storeId, campaignId, data) {
    return Repository(getHeaders(access_token, true)).post(
      `/advertiser/stores/${storeId}/offers/${campaignId}/upload-img`,
      data,
    )
  },
  connectStoreWithGoogleAnalytics(access_token, code, storeId) {
    return Repository(getHeaders(access_token, true)).get(
      `/connect-with-google-analytics?code=${code}&storeId=${storeId}`,
    )
  },
  getAllTrackingConfigs(access_token, storeId) {
    return Repository(getHeaders(access_token, true)).get(
      `/advertiser/stores/${storeId}/order-collectors`,
    )
  },
  updateSelectedGaProperty(access_token, storeId, propertyId) {
    return Repository(getHeaders(access_token, true)).patch(
      `/advertiser/stores/${storeId}/order-collectors/ga?propertyId=${propertyId}`,
    )
  },
  async createStripeSubscription(customerId) {
    return Repository(getHeaders()).post('/advertiser/stripe/create-subscription', {
      customerId,
    })
  },
  async verifySubscription(storeId, subscriptionId) {
    return Repository(getHeaders()).get(
      `/advertiser/stripe/payment/verify/${storeId}/${subscriptionId}`,
    )
  },
  async getPaymentSetupDetails(authorization, id) {
    return Repository(getHeaders(authorization)).get(`/v2/advertisers/${id}/payment-setup`)
  },
}
